module.exports = __webpack_public_path__ + "img/tekken.051221e4.png";